export default __webpack_public_path__ + "static/media/newRequests.45e178a7.svg";